import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import ContentCreationHeader from '../Global/Misc/ContentCreationHeader';
import TextInput from '../Global/Forms/TextInput';
import Button from '../Global/Buttons/Button';
import ButtonGroup from '../Global/Buttons/ButtonGroup';
import IconWithText from '../Global/Icons/IconWithText';
import Icon from '../Global/Icons/Icon';
import RadioButton from '../Global/Forms/RadioButton';

const DiagramCreatorHeader = ({
  loading,
  contentTitle,
  onTitleChange,
  onSaveClick,
  activeItem,
  onDeleteItemClick,
  // onDuplicateItemClick,
  onRotateItemClick,
  onLabelChange,
  currentLabel,
  onLabelFocus,
  onClearCanvasClick,
  onToggleGridClick,
  gridShowing,
  inputRef,
  onTextAlignChange,
  onFontSizeChange,
}) => {
  // We use a hidden class here instead of conditionally rendering as we may want to programitcally
  // focus on the TextInput component which can't be done if it isn't rendered on the page. Hiding
  // instead of conditional rendering means we can focus on it and then unhide it and avoids annoying
  // issues with trying to focus on an input that hasn't quite yet been rendered
  const hiddenClass = 'hidden';

  return (
    <ContentCreationHeader
      contentTitle={contentTitle}
      onTitleChange={onTitleChange}
      onSaveClick={onSaveClick}
      disableSubmit={false}
      loading={loading}
    >
      <div className={`diagram-creator-contextual-btns middle-btns ${activeItem === null ? '' : hiddenClass}`}>
        <ul className="inline-list">
          <li>
            <Button classes="tool-btn" onClick={e => onClearCanvasClick(e)}>
              <IconWithText name="delete-all" size="m">Clear all</IconWithText>
            </Button>
          </li>

          <li>
            <Button classes="tool-btn" onClick={e => onToggleGridClick(e)}>
              <IconWithText name={gridShowing === true ? 'grid-on' : 'grid-off'} size="m">Toggle grid</IconWithText>
            </Button>
          </li>
        </ul>
      </div>

      <div className={`diagram-creator-contextual-btns middle-btns ${activeItem === null ? hiddenClass : ''}`}>
        <ul className="inline-list">
          <li>
            <Button classes="tool-btn" onClick={e => onDeleteItemClick(e)}>
              <IconWithText name="remove-circle-outline" size="m">Delete</IconWithText>
            </Button>
          </li>

          {/* {activeItem &&
            <li>
              <Button classes="tool-btn" onClick={e => onDuplicateItemClick(e)}>
                <IconWithText name="copy" size="m">Duplicate</IconWithText>
              </Button>
            </li>
          } */}

          <li className={activeItem && activeItem.customProps && activeItem.customProps.actions.rotate === true ? '' : hiddenClass}>
            <Button classes="tool-btn" onClick={e => onRotateItemClick(e)}>
              <IconWithText name="rotate" size="m">Rotate</IconWithText>
            </Button>
          </li>

          <li className={activeItem && activeItem.customProps && activeItem.customProps.actions.text === true ? '' : hiddenClass}>
            <TextInput
              name="icon-label"
              onChange={onLabelChange}
              placeholder="Label"
              value={currentLabel}
              maxLength={2}
              onFocus={onLabelFocus}
              inputRef={inputRef}
            />
          </li>

          {activeItem && activeItem.customProps && activeItem.customProps.category === 'text' &&
            <li>
              <ButtonGroup childComponent="radio-button">
                <RadioButton name="text-align" value="left" labelClasses="tool-btn" onChange={onTextAlignChange} checked={activeItem.textAlign === 'left'}>
                  <Icon name="align-left" />
                </RadioButton>
                <RadioButton name="text-align" value="center" labelClasses="tool-btn" onChange={onTextAlignChange} checked={activeItem.textAlign === 'center'}>
                  <Icon name="align-center" />
                </RadioButton>
                <RadioButton name="text-align" value="right" labelClasses="tool-btn" onChange={onTextAlignChange} checked={activeItem.textAlign === 'right'}>
                  <Icon name="align-right" />
                </RadioButton>
              </ButtonGroup>
            </li>
          }

          {activeItem && activeItem.customProps && activeItem.customProps.category === 'text' &&
            <li>
              <Select
                name="sort-by"
                value={activeItem.fontSize}
                onChange={onFontSizeChange}
                clearable={false}
                searchable={false}
                options={activeItem.customProps.fontSizes}
              />
            </li>
          }
        </ul>
      </div>
    </ContentCreationHeader>
  );
};

DiagramCreatorHeader.propTypes = {
  loading: PropTypes.bool,
  contentTitle: PropTypes.string,
  onTitleChange: PropTypes.func,
  onSaveClick: PropTypes.func,
  activeItem: PropTypes.object,
  onDeleteItemClick: PropTypes.func,
  // onDuplicateItemClick: PropTypes.func,
  onRotateItemClick: PropTypes.func,
  currentLabel: PropTypes.string,
  onLabelChange: PropTypes.func,
  onLabelFocus: PropTypes.func,
  onClearCanvasClick: PropTypes.func,
  onToggleGridClick: PropTypes.func,
  gridShowing: PropTypes.bool,
  inputRef: PropTypes.func,
  onTextAlignChange: PropTypes.func,
  onFontSizeChange: PropTypes.func,
};

export default DiagramCreatorHeader;



// WEBPACK FOOTER //
// ./library/app/components/Diagram/DiagramCreatorHeader.js